import React, { useEffect, useState } from "react";
import { message } from 'antd';
import Service from "./../../extra/getAPI";
import Introduce from "./page/1-introduce";
import Package from "./page/2-package";
import Question from "./page/3-question";
import InforBuyer from "./page/4-inforBuyer";
import AddAndEditBuyer from "./page/5-addAndEditBuyer";
import CreateOrder from "./page/6-createOrder";
import "./../../extra/style.css";
import "antd/dist/antd.css";
import Helper from "./../../extra/helper";
import moment from "moment";
export const AuthContext = React.createContext();

const Product = () => {
  const [step, setStep] = useState(1);
  const [title, setTitle] = useState("");
  const [listIsu, setListIsu] = useState([]);
  const [packagedID, setPackagedID] = useState(0);
  const [dataRenewals, setDataRenewals] = useState({});
  const [toltalFees, setToltalFees] = useState(0);
  const [feeInsured, setFeeInsured] = useState(0);
  const platform = Helper.getParamUrlByKey("platform");


  const goStep = (page) => {
    setStep(page);
  };

  useEffect(() => {
    let listInsured = JSON.parse(localStorage.getItem('listInsured'));
    if (listInsured) {
      setListIsu(listInsured);
      getTotalFees();
    }
  }, []);

  const Back = () => {
    setStep(step - 1);
  };

  // const CheckRenewals = (dob, privateId) => {
  //   console.log('cho api moi roi check')
  //   if (!dob || !privateId) return;
  //   if (privateId.length === 7 || privateId.length === 9 || privateId.length === 12) {
  //     let data = {
  //       insuredDob: dob,
  //       insuredPrivateId: privateId
  //     }
  //     setDataRenewals({ "statusCode": 200, "result": { "beginDate": "27/02/2025", "renewals": 0 } })
  //     Service.apicall('POST', '/merchant/v1/product/benh-hiem-ngheo/verify', data).then((res) => {
  //       if (res?.status === 200) {
  //         if (res.data.statusCode === 200) {
  //           setDataRenewals(res.data);
  //         } else {
  //           setDataRenewals(res.data);
  //         }
  //       } else {
  //         message.error('Có sự cố xảy ra vui lòng thử lại!', 10);
  //       }
  //     });
  //   }
  // }

  const ActionList = (action, index, value) => {
    let listIsured = listIsu;
    switch (action) {
      case 'unshift':
        listIsured.unshift(value)
        setListIsu([...listIsured]);
        localStorage.setItem('listInsured', JSON.stringify(listIsured));
        getTotalFees();
        break
      case 'delete':
        listIsured.splice(index, 1);
        setListIsu([...listIsured]);
        localStorage.setItem('listInsured', JSON.stringify(listIsured));
        getTotalFees();
        break;
      case 'add':
        listIsured.push(value);
        setListIsu([...listIsured]);
        localStorage.setItem('listInsured', JSON.stringify(listIsured));
        getTotalFees();
        break;
      case 'edit':
        listIsured[index] = value
        setListIsu([...listIsured]);
        localStorage.setItem('listInsured', JSON.stringify(listIsured));
        getTotalFees();
        break;
    }
  }

  const PageView = () => {
    switch (step) {
      case 1:
        return <Introduce />;
      case 2:
        return <Package />;
      case 3:
        return <Question />;
      case 4:
        return <InforBuyer />;
      case 5:
        return <AddAndEditBuyer />;
      case 6:
        return <CreateOrder />;
    }
  };

  const OpenLink = (link) => {
    if (platform === "app") {
      window.ReactNativeWebView.postMessage(`/gotoBrownser?link=${link}`);
      return;
    }
    window.open(link, "_blank");
  };

  // Tình tuổi
  const getAge = (dob) => {
    let year = dob.slice(6)
    let month = dob.slice(3, 5)
    let day = dob.slice(0, 2)
    const today = new Date();
    let age = today.getFullYear() - +year;
    if (
      today.getMonth() + 1 < +month ||
      (today.getMonth() + 1 == +month && today.getDate() < day)
    ) {
      age--;
    }
    return age;
  }

  const getTotalFees = async (packageId) => {
    if (step === 1) {
      return;
    }
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    let listInsured = JSON.parse(localStorage.getItem('listInsured'));
    if (listInsured?.length > 0) {
      const mappedArray = listInsured?.map(({ insuredDob, insuredGender }) => ({
        insuredDob: moment(insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
        insuredGender: +insuredGender
      }));
      // console.log('mappedArray',mappedArray);
      // return
      const param = {
        yearsOfInsurance: dataIsu.yearsOfInsurance,
        packageId: packageId || dataIsu.package,
        listOfInsuredPeople: mappedArray
      };
      Service.apicall(
        "POST",
        `/v1/products/critical-disease/fees`, param
      )
        .then((res) => {
          if (res.data.success) {
            setToltalFees(res.data.data.fees);
            setFeeInsured(res.data.data.fees);
          }
        })
        .catch((err) => {
          if (err.response) {
            message.error(err?.response?.data?.error?.statusCode + ' | ' + 'Lấy phí thất bại.');
          }
        });
    }
  }

  return (
    <AuthContext.Provider value={{
      listIsu, setListIsu, goStep, step, ActionList, packagedID, setPackagedID,
      setDataRenewals, dataRenewals, Back, OpenLink, getAge, toltalFees, getTotalFees, setToltalFees, feeInsured, setFeeInsured
    }}>
      <div style={{ maxWidth: 800, margin: "0px auto" }}>
        {PageView()}
      </div>
    </AuthContext.Provider>
  );
};

export default Product;
